import {userService} from "../_services";

var state = { cartProducts : [] };
if( localStorage.getItem('cart') )
{
    state.cartProducts = JSON.parse(localStorage.getItem('cart'));
}


const actions = {
    addProduct: (context, product) => {
        context.commit('add_product', product);
    },
    removeProduct: (context, index) => {
        context.commit('remove_products', index);
    },
    resetProducts: (context, index) => {
        context.commit('reset_products', index);
    },
    checkout({ dispatch }, form) {
        userService.addOrder(form)
            .then(
                data => {
                    if(data.status == 'ok')
                    {
                        dispatch('alert/success', 'Ordine registrato!', { root: true });
                    }
                    else
                    {
                        dispatch('alert/error', 'Attenzione! Problema tecnico, ordine non inviato. Riprovare piu tardi!', { root: true });
                    }
                    //router.push('/');
                },
                error => {
                    dispatch('alert/error', error, { root: true });
                }
            );
    }

};

const mutations = {
    add_product: (state, product) => {
        state.cartProducts.push(product);
        localStorage.setItem('cart', JSON.stringify(state.cartProducts));
    },
    remove_products: (state, index) => {
        state.cartProducts.splice(index, 1);
        localStorage.setItem('cart', JSON.stringify(state.cartProducts));
    },
    reset_products: (state) => {
        state.cartProducts = [];
        localStorage.removeItem('cart');
    }
};

export const cart = {
    namespaced: true,
    state,
    actions,
    getters: {
        getProductsInCart: state => state.cartProducts
    },
    mutations
};